/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".legislative-asset-tip-report[_ngcontent-%COMP%]{display:block;width:100%;padding:0;margin:0}.legislative-asset-tip-report[_ngcontent-%COMP%]   .projectTable[_ngcontent-%COMP%]{width:90%;margin-left:auto;margin-right:auto}.legislative-asset-tip-report[_ngcontent-%COMP%]   .projectTable[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{color:#fff;background-color:#20324f;text-align:center}.legislative-asset-tip-report[_ngcontent-%COMP%]   .projectTableSection[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
